import { getDeviceLocale } from "@cabocheck/shared";
import type { LoaderFunctionArgs } from "react-router";
import { data } from "react-router";
import { Link, useLoaderData } from "react-router";
import { useTranslation } from "react-i18next";
import { AquireTest } from "~/features/aquire_test/AquireTest";
import { ProductBanner } from "~/features/products/ProductBanner";
import { ProductBenefits } from "~/features/products/ProductBenefits";
import { ParameterFaqs } from "~/features/products/ParameterFaqs";
import { loadProducts } from "~/utils/apis/loadProducts.server";

export const loader = async ({ params, request }: LoaderFunctionArgs) => {
  const name = params.name;

  if (!name) throw new Response("Not found", { status: 404 });

  const device_locale = getDeviceLocale(request);
  const products = await loadProducts(device_locale);

  const product = products.find((product) => product.name === name);

  if (!product) throw new Response("Not found", { status: 404 });

  const schemaData = {
    "@context": "http://schema.org",
    "@type": "Product",
    name: product.name,
    description: product.description,
    sku: product.medical_test_profile_guid,
    category: "Blood Testing",
    mainEntityOfPage: `https://www.cabocheck.com/tests/products/${product.name}`,
  };

  return data({ product, schemaData });
};

export default function Index() {
  const { product, schemaData } = useLoaderData<typeof loader>();
  const parameters = product.translated.parameters;
  const { t } = useTranslation();

  return (
    <>
      <div id="angebot" className="public-container pt-20">
        <Link to="./../" className="mt-12 text-center text-dynamic-primary sm:text-left">
          {t("Zurück zur Testübersicht")}
        </Link>
        <ProductBanner product={product} />
        <AquireTest />
        <div className="h-20" />
        {/* <ProductInformatives informatives={product.informatives} /> */}
        <div className="grid gap-20 sm:grid-cols-2">
          <ProductBenefits />
          {parameters && parameters.length > 0 ? (
            <div className="grid gap-8">
              {parameters.map((parameter) => (
                <ParameterFaqs key={parameter.name} parameter={parameter} />
              ))}
            </div>
          ) : null}
        </div>
        <div className="h-12" />
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
    </>
  );
}
